import React from 'react';

const InClinicCashIcon = () => {
  return (
<svg width="30" height="23" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="30.5329" y="0.314034" width="13.1061" height="29.1282" transform="rotate(72.3494 30.5329 0.314034)" fill="#66C95D" stroke="#4B7C20" stroke-width="0.5"/>
<path d="M27.9551 4.41594L27.4193 2.69561L1.46796 10.7781L2.00376 12.4985L0.53965 12.9544L3.29842 21.8123L30.7138 13.2738L30.1553 11.4803L31.8024 10.9673L29.6022 3.90294L27.9551 4.41594Z" stroke="#4B7C20" stroke-width="0.5" stroke-linejoin="round"/>
<rect x="35.4922" y="8.07129" width="15.9082" height="35.23" transform="rotate(90 35.4922 8.07129)" fill="#66C95D" stroke="#4B7C20" stroke-width="0.5"/>
<path d="M31.3256 12.3106L31.3256 10.5088L4.14478 10.5088L4.14478 12.3106L2.6113 12.3106L2.6113 21.5881L31.3256 21.5881L31.3256 19.7096L33.0508 19.7096L33.0508 12.3106L31.3256 12.3106Z" stroke="#4B7C20" stroke-width="0.5" stroke-linejoin="round"/>
<circle cx="17.8366" cy="15.9818" r="3.08531" transform="rotate(90 17.8366 15.9818)" fill="#66C95D" stroke="white" stroke-width="0.5"/>
<path d="M15.1966 28.9926L23.8224 24.5455L24.5508 24.2006L9.75275 24.2006L9.75275 22.2071L14.9282 18.4884C16.0937 17.2616 15.5927 15.7792 15.1966 15.1913C14.4605 14.0259 12.8964 14.1946 12.2063 14.4246L5.88073 18.5266C1.31097 19.4774 0.0663029 21.683 0.0151859 22.667L0.0151857 28.9926L15.1966 28.9926Z" fill="#FFCB93"/>
</svg>

    
    
  );
};

export default InClinicCashIcon;
